import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'chemicals_disposed_waste_bin_containers_which_are_generally'

export const dataPointDefinition = {
  retracedId: 'chemicals_disposed_waste_bin_containers_which_are_generally',
  name: 'Chemicals disposed in waste bin containers which are generally used for food and drink',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-che-34x',
      number: 'HS-CHE-13-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-che-29',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-26,Yes- including hazardous substances;Yes- not including hazardous substances',
      machineShowHide: '[2],hs-26,1;2',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-che-34x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30240,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
